module.exports = __webpack_public_path__ + "img/icon-6.4585ca1d.png";